// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cardListHeadingStyles } from "@steiner/Overrides/Components/CardListHeading";
import ArrowRight from "@steiner/XDL/Icons/ArrowRight";
import { color, hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cardListHeadingStyles.container = {
    width: 12,
};
cardListHeadingStyles.innerContainer = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        padding: 12px;
        gap: 8px 34px;
        background: ${color("primary")};
    `,
};
cardListHeadingStyles.title = {
    variant: "h3",
    forwardAs: "h2",
    color: "common.white",
    css: css`
        margin-bottom: 0;
    `,
};

cardListHeadingStyles.viewAll = {
    color: "common.white",
    icon: {
        position: "right",
        iconProps: {
            src: ArrowRight,
            color: "common.white",
            size: 16,
            css: css`
                opacity: 0.66;
                margin-left: 6px;
            `,
        },
    },
    css: css`
        white-space: nowrap;
        position: relative;
        /* &::after {
            content: "";
            position: absolute;
            left: -17px;
            background: ${color("common.white")};
            width: 1px;
            height: 30px;
            opacity: 0.66;
        }

        ${xScreen("lte", "md")} {
            &::after {
                display: none;
            }
        } */

        ${hideElementOnPrint}
    `,
};
